// helperHome.jsx
import React, { useState, useEffect } from 'react';
import Joyride from 'react-joyride';

const TOUR_STORAGE_KEY = 'helperHomeTourSeen';

/**
 * HelperHome
 * Guida interattiva per la dashboard Home (Benvenuto, News, Presenze, Riepilogo)
 * @param {{ canShowAttendance: boolean, hasNews: boolean, hasRiepilogo: boolean ,run, onFinish}} props
 */
export default function HelperHome({ canShowAttendance, hasNews, hasRiepilogo ,run, onFinish}) {
  // prossimi turnu
  const nextShiftsSteps = [
    { target: '#next-shifts', content: 'Agenda dei prossimi impegni di servizio.', disableBeacon: true },
  ];
  
  // presenze
  const attendanceSteps = canShowAttendance ? [
    { target: '#home-attendance', content: 'Qui puoi timbrare la tua presenza.', disableBeacon: true },
  ] : [];
  // news
  const newsSteps = hasNews ? [
    { target: '#home-news', content: 'Leggi le ultime notizie qui.', disableBeacon: true },
  ] : [];
  // riepilogo formazione
  const riepilogoSteps = hasRiepilogo ? [
    { target: '#home-riepilogo', content: 'Visualizza il riepilogo delle formazioni.', disableBeacon: true },
  ] : [];

  const steps = [ ...attendanceSteps, ...nextShiftsSteps, ...newsSteps, ...riepilogoSteps];
  

  useEffect(() => {
    // non partire automaticamente
    localStorage.getItem(TOUR_STORAGE_KEY);
  }, []);

  const handleStart = () => {
    localStorage.setItem(TOUR_STORAGE_KEY, 'true');
    setRun(true);
  };

  const handleCallback = (data) => {
    if (['finished','skipped'].includes(data.status)) setRun(false);
  };

// helperHome.jsx

return (
  <Joyride
    steps={steps}
    run={run}
    continuous
    showSkipButton
    disableBeacon
    disableOverlayClose
    callback={onFinish}
    // AGGIUNGI QUESTO BLOCCO PER L'ITALIANO
    locale={{
      back: 'Indietro',
      close: 'Chiudi',
      last: 'Fine',
      next: 'Avanti',
      skip: 'Salta il Tour'
    }}
    styles={{
      options: {
        primaryColor: '#1a365d', // Il tuo blu notte
        zIndex: 10000,
      },
      // Opzionale: rende i bottoni più "PRO"
      buttonNext: {
        borderRadius: '8px',
        fontWeight: 800,
        textTransform: 'uppercase',
        fontSize: '12px'
      },
      buttonBack: {
        fontWeight: 800,
        fontSize: '12px',
        color: '#1a365d'
      }
    }}
  />
);
}
